import React from 'react';

import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { ArrowDownSLine } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import {
  ResponsiveSearchDrawerItemContent,
  ResponsiveSearchDrawerItemLabel,
} from './styled';

interface ResponsiveDrawerInterface {
  icon:
    | React.FunctionComponent<
        React.SVGProps<SVGSVGElement> | CustomIconComponentProps
      >
    | React.ComponentClass<
        React.SVGProps<SVGSVGElement> | CustomIconComponentProps,
        any
      >
    | undefined;

  title: string;
  subTitle: string;
  arrowIcon: boolean;
  onClick:
    | ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void)
    | undefined;

  className?: string;
  error?: boolean;
  isFilled?: boolean;
}

const ResponsiveSearchDrawerItem: React.FC<ResponsiveDrawerInterface> = ({
  icon,
  title,
  subTitle,
  arrowIcon,
  onClick,
  className,
  error,
  isFilled,
}) => {
  const onKeyPress = (e: any): void => {
    const enterOrSpace =
      e.key === 'Enter' ||
      e.key === ' ' ||
      e.key === 'Spacebar' ||
      e.which === 13 ||
      e.which === 32;
    if (enterOrSpace) {
      e.preventDefault();
      if (onClick) onClick(e);
    }
  };

  return (
    <ResponsiveSearchDrawerItemContent
      onKeyPress={onKeyPress}
      role='button'
      tabIndex={-1}
      onClick={onClick}
      className={className}
      hasError={error || false}
    >
      <CustomIcon icon={icon} fontSize={20} paletteColor='grey500' />
      <ResponsiveSearchDrawerItemLabel isFilled={isFilled}>
        {isFilled ? subTitle : title}
      </ResponsiveSearchDrawerItemLabel>

      {arrowIcon && (
        <CustomIcon
          fontSize={20}
          icon={ArrowDownSLine}
          paletteColor='grey800'
        />
      )}
    </ResponsiveSearchDrawerItemContent>
  );
};

export default ResponsiveSearchDrawerItem;
